import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { inject, observer } from 'mobx-react';

const LAZY_LOAD_OFFSET = 4000;
const LAZY_LOAD_OFFSET_MOBILE = 1000;

class LazyLoadDefault extends React.Component {
  static propTypes = {
    envStore: PropTypes.object.isRequired,
  };

  render() {
    const { envStore } = this.props;

    return (
      <LazyLoad height={100} offset={envStore.isScreenMobile() ? LAZY_LOAD_OFFSET_MOBILE : LAZY_LOAD_OFFSET} once>
        {this.props.children}
      </LazyLoad>
    );
  }
}

export default inject(stores => ({
  envStore: stores.store.envStore,
}))(observer(LazyLoadDefault));



// WEBPACK FOOTER //
// ./src/components/LazyLoadDefault.js